import React, { useState, useEffect, useContext } from 'react'
import ShowMoreText from 'react-show-more-text'
import { XL_SIZE } from '../../utils/constants'
import { useParams, useNavigate } from 'react-router'
import {
  CONTENT_FILTERING,
  CONTENT_WATCH_URL,
  IPTV_CHANNEL_SCHEDULE,
  GET_ACTIVE_SUBSCRIPTIONS,
  IPTV_CHANNEL_FILTER,
  OVERRIDE_FEED_API,
  // GET_REVIEWS_API,
} from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import {
  convertToLocalTime,
  getImage,
  xmlParser,
  findCurrentPlayingProgram,
} from '../../utils/helper'
import { AppContext } from '../../context/app'
import { intersectionWith, isEmpty, isEqual } from 'lodash'
import { SubscriptionContext } from '../../context/subscription'
import moment from 'moment'
import { useInterval } from '../../hooks/useInterval'
import { useTranslation } from 'react-i18next'
import ChannelPlayer from '../player/channelPlayer'
import CustomMetadata from '../../components/customMetadata/customMetadata'
import ReviewsListing from '../../components/reviewRating'
import CommentListing from '../../components/comments'
import ChannelBottom from '../channel/channelBottom'
import { withTheme } from 'theming'
import IptvChannelEPG from './iptvChannelEPG'
import CustomImage from '../../components/customImage/customImage'
import LockIcon from '../../assets/lock-icon.svg'

function IPTV({ theme }) {
  const channelId = useParams().channelId
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isLogin, setOpenLoginModal, setModalType, accountObj } = useContext(AppContext)
  const {
    activeSubscription,
    setOpenSubscriptionModal,
    setSubscriptions,
    setRedirectionUrl,
    setContentPartners,
  } = useContext(SubscriptionContext)
  const [detailObj, setDetailObj] = useState({})
  const [showMore, setShowMore] = useState(false)
  const [isChannelSubscribed, setIsChannelSubscribed] = useState(true)
  const [currentPlayingContent, setCurrentPlayingContent] = useState({})
  const [currentPlayingEndTime, setCurrentPlayingEndTime] = useState(null)
  const [nextStartTime, setNextStartTime] = useState(null)
  const [playerQueue, setPlayerQueue] = useState([])
  const [videoSource, setVideoSource] = useState(null)
  const [scheduleData, setScheduleData] = useState([])
  const [epgData, setEpgData] = useState([])
  const [videoURLError, setVideoURLError] = useState('')
  const [iptvLoader, setIptvLoader] = useState(false)
  const [isXL, setIsXL] = useState(window.innerWidth >= XL_SIZE)
  const [overrideFeedData, setOverrideFeedData] = useState({})
  const isOverrideFeedEnabled = accountObj?.od_resource_allowances?.is_channel_feed_override_enabled
  let isRatingOnly = accountObj?.od_resource_allowances?.rating_review === 'RATING'

  // const [{ data: reviewList, loading: reviewListLoading }] = useAxios({
  //   url: GET_REVIEWS_API + '/channel/' + channelId,
  //   method: 'get',
  // })

  const [{ data: channelDetails, loading: channelDetailsLoading }, channelDetailsCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER,
      method: 'post',
    },
    {
      manual: true,
    },
  )

  const [{ data: channelSchedule, loading: channelScheduleLoading }, channelScheduleCall] =
    useAxios(
      {
        url: IPTV_CHANNEL_SCHEDULE,
        method: 'get',
      },
      {
        manual: true,
      },
    )

  const [{ loading: scheduleContentLoading }, scheduleContentCall] = useAxios(
    {
      url: CONTENT_FILTERING,
      method: 'post',
    },
    { manual: true },
  )

  const [
    { data: contentWatchUrl, error: contentUrlError, loading: contentWatchUrlLoading },
    getContentWatchUrl,
  ] = useAxios(
    {
      url: `${CONTENT_WATCH_URL}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ loading: activeSubLoading }, activeSubCall] = useAxios(
    {
      url: GET_ACTIVE_SUBSCRIPTIONS,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: overrideFeedInfo, error: overrideFeedError }, overrideFeedCall] = useAxios(
    {
      url: `${OVERRIDE_FEED_API}/${channelId}`,
      method: 'get',
    },
    { manual: true, autoCancel: false },
  )

  useEffect(() => {
    setIptvLoader(
      channelDetailsLoading ||
        channelScheduleLoading ||
        // reviewListLoading ||
        scheduleContentLoading ||
        contentWatchUrlLoading ||
        activeSubLoading,
    )
  }, [
    channelDetailsLoading,
    channelScheduleLoading,
    // reviewListLoading,
    scheduleContentLoading,
    contentWatchUrlLoading,
    activeSubLoading,
  ])

  useEffect(() => {
    const handleResize = () => {
      setIsXL(window.innerWidth >= XL_SIZE)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (contentWatchUrl && contentWatchUrl.success) {
      setVideoSource(contentWatchUrl?.data?.signed_url)
    }
  }, [contentWatchUrl])

  useEffect(() => {
    if (contentUrlError?.response) {
      setVideoURLError(contentUrlError?.response?.data?.message)
    }
  }, [contentUrlError])

  useInterval(
    async () => {
      if (isOverrideFeedEnabled) {
        await overrideFeedCall()
      }
    },
    isOverrideFeedEnabled ? 5000 : null,
  )

  useEffect(() => {
    console.error(overrideFeedError)
  }, [overrideFeedError])

  useEffect(() => {
    if (overrideFeedInfo && overrideFeedInfo?.success) {
      const overrideObj = overrideFeedInfo?.data

      if (!isEmpty(overrideObj) && overrideObj?.url) {
        const currentTime = new Date()
        const feedStartTime = new Date(overrideObj?.start_time)
        const feedEndTime = overrideObj?.end_time ? new Date(overrideObj?.end_time) : null

        // Determine if override feed should be played:
        // - publish_policy is NOT DRAFT
        // - current time >= feed start time
        // - current time < feed end time (if end time exists, otherwise continuous)
        const shouldPlayOverride =
          overrideObj?.publish_policy !== 'DRAFT' &&
          currentTime >= feedStartTime &&
          (!feedEndTime || currentTime < feedEndTime)

        console.log('shouldPlayOverride', shouldPlayOverride)

        if (shouldPlayOverride) {
          // Play override feed
          setOverrideFeedData(overrideObj)

          // Update video source if different
          if (overrideObj?.url !== videoSource) {
            setVideoSource(overrideObj?.url)
          }

          // Set end time only if it exists
          // if (feedEndTime) {
          //   const endTimeMs = new Date(overrideObj?.end_time + 'Z').getTime()
          //   if (endTimeMs !== currentPlayingEndTime) {
          //     setCurrentPlayingEndTime(endTimeMs)
          //   }
          // }
        } else {
          if (overrideObj?.url === videoSource) {
            setVideoSource(null)
            // Override feed should not play, restore schedule content
            setOverrideFeedData({})

            if (detailObj?.type === 'EXTERNAL') {
              setVideoSource(detailObj?.feed_url)
            } else if (!isEmpty(currentPlayingContent)) {
              // Restore schedule content if one is currently playing
              handleVideoSource()
            }
          }
        }
      }
    }
  }, [overrideFeedInfo])

  useEffect(() => {
    setVideoSource(null)
    setCurrentPlayingContent({})
    channelDetailsCall({
      data: {
        filters: { channel_ids: [channelId] },
        page: '1',
      },
    })

    channelScheduleCall({
      params: {
        channel_id: channelId,
        start_time: moment().subtract(90, 'minutes').toISOString(),
        end_time: moment().add(48, 'hours').toISOString(),
      },
    })
  }, [channelId])

  useEffect(async () => {
    if (channelDetails && channelDetails.success && !isEmpty(channelDetails?.data)) {
      let tempData = channelDetails.data[0]
      setDetailObj(tempData)
      if (tempData?.type === 'EXTERNAL') {
        setVideoSource(tempData?.feed_url)
        if (tempData?.epg_url) {
          const epg = await xmlParser(tempData.epg_url)
          setEpgData(epg?.programs || [])
        } else {
          setEpgData([])
        }
      }
    }
  }, [channelDetails])

  useEffect(async () => {
    if (!isEmpty(epgData) && detailObj?.type === 'EXTERNAL') {
      const currentProgram = findCurrentPlayingProgram(epgData)
      if (currentProgram) {
        setCurrentPlayingContent(currentProgram)
        setCurrentPlayingEndTime(currentProgram.end_time)
      }
    }
  }, [epgData])

  useEffect(async () => {
    if (channelSchedule && channelSchedule.success) {
      let tempSchduleArr = []
      let contentIDs = channelSchedule?.data.map((info) => info?.content_id)
      let contents = await scheduleContentCall({
        data: {
          filters: {
            content_ids: contentIDs,
          },
          page: 1,
          page_size: contentIDs.length,
        },
      })

      for (let i = 0; i < channelSchedule?.data.length; i++) {
        const scheduledContent = channelSchedule?.data[i]
        let contentObj = contents.data?.data.find(
          (content) => content.content_id === scheduledContent?.content_id,
        )

        if (contentObj) {
          tempSchduleArr.push({
            ...scheduledContent,
            contentDetail: contentObj,
          })
        }
      }
      setScheduleData([...tempSchduleArr])
    }
  }, [channelSchedule, isLogin])

  useEffect(async () => {
    if (!isEmpty(detailObj) && !isEmpty(scheduleData)) {
      if (await checkRestriction()) {
        // Get today's content
        let todaysContents = scheduleData.filter((ele) => {
          return (
            moment(new Date(ele.start_time + 'Z')).format('DD-MM-YYYY') ===
              moment().format('DD-MM-YYYY') ||
            moment(new Date(ele.end_time + 'Z')).format('DD-MM-YYYY') ===
              moment().format('DD-MM-YYYY')
          )
        })

        // if (todaysContents.length > 0) {
        //   const testContent = todaysContents[0]
        //   setCurrentPlayingContent(testContent.contentDetail)
        //   setCurrentPlayingEndTime(convertToLocalTime(testContent.end_time, false, 'long'))
        // }

        let tempPlayerQueue = []
        for (let i = 0; i < todaysContents.length; i++) {
          const content = todaysContents[i]
          const startTime = moment(convertToLocalTime(content.start_time), 'HH:mm:ss [GMT]ZZ')
          const endTime = moment(convertToLocalTime(content.end_time), 'HH:mm:ss [GMT]ZZ')
          const time = moment(new Date(), 'HH:mm:ss [GMT]ZZ')

          if (time.isSameOrAfter(startTime) && time.isSameOrBefore(endTime)) {
            setCurrentPlayingContent(content.contentDetail)
            setCurrentPlayingEndTime(convertToLocalTime(content.end_time, false, 'long'))
            continue
          }

          if (time.isBefore(startTime)) {
            tempPlayerQueue.push(content)
            continue
          }
        }

        setPlayerQueue([
          ...tempPlayerQueue.sort((first, second) => first.start_time - second.start_time),
        ])
      }
    }
  }, [detailObj, scheduleData, isLogin])

  useInterval(async () => {
    if (currentPlayingEndTime) {
      const time = moment(new Date(), 'HH:mm:ss').format('HH:mm:ss')

      if (currentPlayingEndTime.includes(time)) {
        if (isEmpty(overrideFeedData)) {
          setVideoSource(null)
        }
        setCurrentPlayingContent({})
        setCurrentPlayingEndTime(null)
      }
    }
  }, 1000)

  useInterval(async () => {
    if (nextStartTime) {
      const time = moment(new Date(), 'HH:mm:ss').format('HH:mm:ss')

      if (nextStartTime.includes(time)) {
        setCurrentPlayingContent(playerQueue[0].contentDetail)
        setCurrentPlayingEndTime(convertToLocalTime(playerQueue[0].end_time, false, 'long'))
        setNextStartTime(
          playerQueue.length > 2
            ? convertToLocalTime(playerQueue[1].start_time, false, 'long')
            : null,
        )
        let tempQueue = playerQueue.filter((e, idx) => idx !== 0)
        setPlayerQueue([...tempQueue])
      }
    }
  }, 1000)

  // For external EPG channels, periodically update current playing program
  useInterval(async () => {
    if (!isEmpty(epgData) && detailObj?.type === 'EXTERNAL') {
      const currentProgram = findCurrentPlayingProgram(epgData)
      if (currentProgram) {
        setCurrentPlayingContent(currentProgram)
        setCurrentPlayingEndTime(currentProgram.end_time)
      } else {
        // No program is currently playing
        setCurrentPlayingContent({})
        setCurrentPlayingEndTime(null)
      }
    }
  }, 5000)

  useEffect(async () => {
    if (!isEmpty(playerQueue)) {
      setNextStartTime(convertToLocalTime(playerQueue[0].start_time, false, 'long'))
    }
  }, [playerQueue])

  useEffect(async () => {
    if (
      !isEmpty(currentPlayingContent) &&
      isEmpty(overrideFeedData) &&
      !isEmpty(detailObj) &&
      detailObj?.type !== 'EXTERNAL'
    ) {
      handleVideoSource()
    }
  }, [currentPlayingContent, overrideFeedData])

  const handleVideoSource = () => {
    if (isEmpty(currentPlayingContent) || !isEmpty(overrideFeedData)) return
    if (currentPlayingContent.is_live && !isEmpty(currentPlayingContent.stream)) {
      setVideoSource(currentPlayingContent.stream.link)
      return
    }

    if (!currentPlayingContent.is_live && !isEmpty(currentPlayingContent?.youtube_data)) {
      setVideoSource(currentPlayingContent?.youtube_data)
      return
    }
    getContentWatchUrl({ url: `${CONTENT_WATCH_URL}${currentPlayingContent.content_id}` })
  }

  const checkPlanExist = (contentActiveSubscription, userSubscription) => {
    return !isEmpty(intersectionWith(contentActiveSubscription, userSubscription, isEqual))
  }

  const emptySubcheck = async (channelSub) => {
    const subRes = await activeSubCall()
    const activeSub = subRes.data.data
      .filter((item) => item.status)
      .map((item) => item.subscription)
    return !isEmpty(intersectionWith(channelSub, activeSub, isEqual))
  }

  const checkRestriction = async (openModal = false) => {
    if (!detailObj.is_restricted) {
      return true
    } else {
      if (!isLogin) {
        if (openModal) {
          setModalType('login')
          setOpenLoginModal(true)
        }
        setIsChannelSubscribed(false)
        return false
      } else {
        let channelSub = [
          ...detailObj?.active_subscription.map((item) => item._id),
          ...detailObj?.active_ppv.map((item) => item._id),
        ]
        const planExist = isEmpty(activeSubscription)
          ? await emptySubcheck(channelSub)
          : checkPlanExist(channelSub, activeSubscription)

        if (!planExist) {
          setIsChannelSubscribed(false)
          if (openModal) {
            setRedirectionUrl(window.location.pathname)
            setContentPartners(detailObj?.owner ? detailObj?.owner : [])
            setSubscriptions(channelSub)
            setOpenSubscriptionModal(true)
          }
        } else {
          return true
        }
        return false
      }
    }
  }

  const getResumeTimestamp = () => {
    if (isEmpty(currentPlayingContent) || !isEmpty(overrideFeedData)) return 0

    const currentScheduledContent = scheduleData.filter(
      (info) =>
        info.content_id === currentPlayingContent?.content_id &&
        moment(new Date(info?.end_time + 'Z')).format('DD-MM-YYYY HH:mm') ===
          moment(moment(new Date()).format('MM-DD-YYYY') + ' ' + currentPlayingEndTime).format(
            'DD-MM-YYYY HH:mm',
          ),
    )

    if (currentScheduledContent.length === 1) {
      const content = currentScheduledContent[0]

      let duration = moment.duration(
        moment(new Date(), 'HH:mm').diff(moment(convertToLocalTime(content.start_time), 'HH:mm')),
      )
      return duration.asSeconds()
    }

    return 0
  }

  const handleCategoryClick = (id) => {
    if (!id) return
    navigate(`/metadata/${id}`)
  }

  const handleSubCategory = (id) => {
    navigate(`/sub-category/${id}`)
  }

  const getCurrentContentTiming = () => {
    if (currentPlayingContent?.title && !isEmpty(scheduleData)) {
      const currentScheduledContent = scheduleData.find(
        (info) => info.content_id === currentPlayingContent?.content_id,
      )

      if (currentScheduledContent) {
        return `${convertToLocalTime(currentScheduledContent.start_time)} - ${convertToLocalTime(
          currentScheduledContent.end_time,
        )}`
      }
    }
    return ''
  }

  const menuComponents = [
    {
      title: isRatingOnly ? t('rating') : t('reviews'),
      child: (
        <ReviewsListing
          type={'channel'}
          id={channelId}
          title={detailObj?.title}
          isRefreshed={channelDetailsLoading}
        />
      ),
    },
    {
      title: t('comments'),
      child: <CommentListing type={'channel'} id={channelId} theme={theme} />,
    },
  ]

  return (
    <div className="w-full h-full">
      <div className="flex flex-col xl:flex-row xl:justify-between xl:mt-3 px-0 2xl:max-w-[1630px] xl:max-w-[1297px] 2xl:h-[573px] xl:h-[433px] mx-auto">
        {/* Logo - Mobile  */}
        <div className="flex xl:hidden w-full justify-center items-center">
          <CustomImage
            imageUrl={getImage(accountObj?.cf_domain_name, detailObj?.logo?.website?.s3_key)}
            alt="logo"
            imgClass="h-9 w-[101px]"
            loaderClass="h-9 w-[101px]"
          />
        </div>

        {/* Heading - Mobile Only */}
        <div className="mb-3 xl:hidden text-center">
          <h3 className="test-xs font-semibold mb-1 text-white">{detailObj?.name}</h3>
        </div>

        {/* Video Player */}
        <div
          className={`${
            iptvLoader && 'animate-pulse'
          } bg-black rounded-xl w-full xl:w-[769px] 2xl:w-[1018px] mb-3 xl:mb-0 overflow-hidden`}
          style={{ aspectRatio: '1.777' }}
        >
          {videoSource && (
            <ChannelPlayer
              contentInfo={currentPlayingContent}
              contentWatchUrl={videoSource}
              resumeTime={isEmpty(overrideFeedData) ? getResumeTimestamp() : 0}
              watermarkLogo={detailObj?.logo?.website?.s3_key}
              detailObj={detailObj}
            />
          )}

          {videoURLError && !videoSource ? (
            <div className="w-full h-full flex justify-center items-center">
              <div className="flex flex-col items-center">
                <div className="w-full h-full flex justify-center items-center ">
                  <div className=" w-4/5 md:w-fit">
                    <p
                      style={{ color: '#cecece' }}
                      className="md:ml-2 text-xs md:text-base xl:text-lg text-center font-semibold"
                    >
                      {videoURLError}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {!videoSource ? (
            !isChannelSubscribed ? (
              <div className=" w-full h-full flex flex-col items-center justify-center">
                <div className="flex px-5 md:px-0">
                  <img
                    src={LockIcon}
                    style={{
                      width: '18.5px',
                      height: '24.6px',
                    }}
                    alt="LockIcon"
                  />
                  <p
                    style={{ color: '#cecece' }}
                    className="md:ml-2 text-xs md:text-base xl:text-lg text-center "
                  >
                    {t('this_channel_not_included')}
                  </p>
                </div>
                <button
                  style={{ background: '#09e9e9', color: '#000' }}
                  className="w-[70%] text-xs md:text-base xl:text-lg rounded-md xl:rounded-lg mt-4 xl:mt-6 py-1"
                  onClick={() => checkRestriction(true)}
                >
                  {t('upgrade_membership_to_watch')}
                </button>
              </div>
            ) : (
              <div className="w-full h-full flex flex-col justify-center items-center">
                <CustomImage
                  imageUrl={getImage(accountObj?.cf_domain_name, detailObj?.logo?.website?.s3_key)}
                  imgAlt="channelimg"
                  imgClass={`   h-6 w-9 md:h-12 md:w-20 `}
                  loaderClass={`   h-6 w-9 md:h-12 md:w-20 `}
                />
                <p
                  style={{ color: '#cecece' }}
                  className="md:ml-2 text-xs md:text-base xl:text-lg text-center "
                >
                  {t('no_programs_shown_at_moment')}
                </p>
              </div>
            )
          ) : null}
        </div>

        {/* Right Side Content */}
        <div
          className={`${
            iptvLoader && 'animate-pulse'
          } w-full xl:w-[493px] 2xl:w-[561px] flex flex-col px-3 xl:px-0 relative`}
        >
          {/* Logo - Desktop Only */}
          <div className="hidden w-full xl:flex justify-center items-center">
            <CustomImage
              imageUrl={getImage(accountObj?.cf_domain_name, detailObj?.logo?.website?.s3_key)}
              alt="logo"
              imgClass=" xl:h-[50px] 2xl:h-[71px]"
              loaderClass=" xl:h-[50px] 2xl:h-[71px]"
              imgStyle={{ aspectRatio: '1.7857' }}
              loaderStyle={{ aspectRatio: '1.7857' }}
            />
          </div>

          {/* Heading - Desktop  */}
          <div className="hidden xl:block text-center mt-1">
            <h3 className="2xl:text-[22px] text-base font-semibold mb-1 text-white">
              {detailObj?.name}
            </h3>
            <p className="2xl:text-xs text-[11px] mt-3 px-4" style={{ color: '#ACACAC' }}>
              {detailObj?.description}
            </p>
          </div>

          <div
            style={{ borderTop: '1px solid #707070' }}
            className="hidden xl:block xl:mt-[14px]"
          />

          {/* Streaming Now Label */}

          {!isEmpty(currentPlayingContent) ? (
            <div className="text-sm uppercase mt-2 xl:mt-3 2xl:mt-4" style={{ color: '#007FFF' }}>
              {t('streaming_now')}
            </div>
          ) : null}

          {/* Content Area */}
          {!isEmpty(currentPlayingContent) ? (
            <div className="flex gap-4 xl:gap-5 mb-3 xl:mb-4 flex-1 overflow-hidden">
              <div className="flex-1 flex flex-col">
                <p className="font-bold mb-1 text-sm xl:text-sm 2xl:text-base text-white">
                  {currentPlayingContent?.title}
                </p>
                <p className="text-xs text-white mb-2">{getCurrentContentTiming()}</p>

                <div className="mb-3 xl:mb-0 flex-1 overflow-y-auto hidden-scrollbar-class">
                  <p className="text-xs mb-3" style={{ color: '#ACACAC' }}>
                    <ShowMoreText
                      lines={isXL ? 4 : 3}
                      more={<span style={{ color: '#4DA6FF' }}>show more</span>}
                      less={<span style={{ color: '#4DA6FF' }}>show less</span>}
                      anchorClass="text-sm cursor-pointer"
                      className="w-full text-xs"
                      expanded={showMore}
                      onClick={() => setShowMore(!showMore)}
                      truncatedEndingComponent={'... '}
                    >
                      <p className="w-full">{currentPlayingContent?.description}</p>
                    </ShowMoreText>
                  </p>

                  <div className="grid grid-cols-[auto_1fr] gap-x-[43px] 2xl:gap-x-16 gap-y-2 2xl:text-sm text-xs">
                    {/* Category metadata  */}
                    {currentPlayingContent?.category &&
                      !isEmpty(currentPlayingContent?.category) && (
                        <>
                          <span style={{ color: '#B2B2B2' }}>Category</span>
                          <span style={{ color: '#4DA6FF' }}>
                            {[...currentPlayingContent?.category].map((item, index) => (
                              <span
                                key={index}
                                onClick={
                                  detailObj?.type === 'EXTERNAL'
                                    ? () => {}
                                    : () => handleCategoryClick(item?.id)
                                }
                                className={`${
                                  detailObj?.type === 'EXTERNAL'
                                    ? ''
                                    : 'cursor-pointer hover:underline'
                                } `}
                              >
                                {index !== 0 && <span>{', '}</span>}
                                {item.name}
                              </span>
                            ))}
                          </span>
                        </>
                      )}

                    {/* Sub Category / Genre metadata */}
                    {currentPlayingContent?.sub_category &&
                      !isEmpty(currentPlayingContent?.sub_category) && (
                        <>
                          <span style={{ color: '#B2B2B2' }}>Genre</span>
                          <span style={{ color: '#4DA6FF' }}>
                            {(currentPlayingContent?.sub_category).map((item, index) => (
                              <span
                                key={index}
                                onClick={() => handleSubCategory(item.id)}
                                className={'cursor-pointer hover:underline'}
                              >
                                {index !== 0 && <span>{', '}</span>}
                                {item.name}
                              </span>
                            ))}
                          </span>
                        </>
                      )}

                    {/* Venues metadata  */}
                    {currentPlayingContent?.venues && !isEmpty(currentPlayingContent?.venues) && (
                      <>
                        <span style={{ color: '#B2B2B2' }}>Venue</span>
                        <span style={{ color: '#4DA6FF' }}>
                          {(currentPlayingContent?.venues).map((item, index) => (
                            <span
                              key={index}
                              onClick={() => navigate(`/venue/detail/${item.id}`)}
                              className={'cursor-pointer hover:underline'}
                            >
                              {index !== 0 && <span>{', '}</span>}
                              {item.name}
                            </span>
                          ))}
                        </span>
                      </>
                    )}

                    {/* Custom Metadata  */}
                    {currentPlayingContent?.custom_metadata_new && (
                      <CustomMetadata
                        customMetadata={currentPlayingContent?.custom_metadata_new}
                        valueColor="#4DA6FF"
                        valueFontFamily=""
                        valueFontFormat=""
                        parentDivClass="contents"
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* Thumbnail Image  */}
              <div className="w-[143px] xl:w-[151px] 2xl:w-48">
                <CustomImage
                  imageUrl={
                    detailObj?.type === 'EXTERNAL'
                      ? currentPlayingContent?.thumbnail ||
                        getImage(accountObj?.cf_domain_name, detailObj?.logo?.website?.s3_key)
                      : getImage(accountObj?.cf_domain_name, currentPlayingContent?.thumbnail)
                  }
                  alt="ContentImage"
                  imgClass="w-full h-20 xl:h-[85px] 2xl:h-[107px] object-contain bg-black"
                  style={{ border: '0.5px solid #FFFFFF', borderRadius: '2px' }}
                />
              </div>
            </div>
          ) : null}

          <hr className="mb-3 xl:hidden border-gray-700" />

          {/* Legend */}
          <div
            style={{ background: theme.c1 }}
            className="xl:absolute bottom-0 flex items-center gap-2 xl:gap-5 text-[10px] xl:text-xs 2xl:text-sm text-white py-1"
          >
            <div className="flex items-center">
              <div
                className="w-3 h-3 xl:w-[14px] xl:h-[14px] 2xl:w-5 2xl:h-5 rounded"
                style={{ background: '#11171F', border: '1px solid #727272' }}
              ></div>
              <span className="2xl:ml-3 xl:ml-[10px] ml-1">Program</span>
            </div>
            <div className="flex items-center">
              <div
                className="w-3 h-3 xl:w-[14px] xl:h-[14px] 2xl:w-5 2xl:h-5 rounded"
                style={{ background: '#141446', border: '1px solid #1F51FF' }}
              ></div>
              <span className="2xl:ml-3 xl:ml-[10px] ml-1">Streaming Now</span>
            </div>
            <div className="flex items-center">
              <div
                className="w-3 h-3 xl:w-[14px] xl:h-[14px] 2xl:w-5 2xl:h-5 rounded"
                style={{ background: '#5C1921', border: '1px solid #FF3131' }}
              ></div>
              <span className="2xl:ml-3 xl:ml-[10px] ml-1">LIVE NOW</span>
            </div>
            <div className="flex items-center">
              <div
                className="w-3 h-3 xl:w-[14px] xl:h-[14px] 2xl:w-5 2xl:h-5 rounded"
                style={{ background: '#5C3819', border: '1px solid #FF9300' }}
              ></div>
              <span className="2xl:ml-3 xl:ml-[10px] ml-1">Upcoming LIVE</span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full 2xl:max-w-[1630px] xl:max-w-[1297px] mx-auto mt-[21px]">
        <IptvChannelEPG />
      </div>
      <div className="w-full  2xl:max-w-[88.8%] xl:max-w-[1297px] mx-auto mt-8">
        <ChannelBottom options={menuComponents} />
      </div>
    </div>
  )
}

export default withTheme(IPTV)
